module.exports = __webpack_public_path__ + "static/media/logo.8dd6be35.png";